import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  pickingCriteriaProcessFetchPickingCriteriaProcess: null,
  pickingCriteriaProcessFetchPickingCriteriaProcessLoading: ['boolean'],
  pickingCriteriaProcessFetchPickingCriteriaProcessSuccess: ['process']
});

export const PickingCriteriaProcessTypes = Types;
export default Creators;
